import Axios from 'axios'
import { useContext } from 'react'
import { GuestContext } from '../Guest.context'
const axiosInstance = Axios.create()

export const useAxios = () => {
    const { token } = useContext(GuestContext)
    if (token !== axiosInstance.defaults.headers.common.Authorization) {
        axiosInstance.defaults.headers.common.Authorization = token
    }
    return axiosInstance
}
